<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length || routeName == 'profile_gst'">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-buttons slot="end">
                <ion-button class="pill next-pill-button" v-if="routeName == 'auth_gst'" @click="skip">
                    Skip
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
        <div class="main_wrapper ion-padding">
            <div class="container">

                <page-title title="GST Registered" subtitle="Are you registered for GST?" showIcon />
                <el-form :model="formsData.userForm" :rules="formsData.userForm.rules"
                    :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'"
                    @submit.prevent="save('userForm')" @keyup.enter="save('userForm')" class="full_page">

                    <div class="footer">
                        <el-form-item>
                            <el-button class="submit" type="blue" @click="setGst(1)">
                                Yes
                            </el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="reject" type="blue" @click="setGst(0)">
                                No 
                            </el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>


    </div>
</template>

<script>
import './Gst.scss';
import {
    onMounted,
    inject,
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import PageTitle from '@/components/PageTitle/PageTitle.vue';


addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from "@ionic/vue";

import { useStore } from "vuex";
import {
    useRouter,
    useRoute,

} from "vue-router";
import formHooks from "@/hooks/form/form";
import { ElMessageBox } from "@/components/Vendor/Element";
import isEmpty from "lodash/isEmpty";


export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        PageTitle,
    },

    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute()
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        const routeName = $route.name;

        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const setNoGst = () => {
            formsData.userForm.gst.value = 0;
            formsData.userForm.gstNumber.value = '';
            save('userForm');
        }

        const formsDataArray = {
            userForm: {
                gst: {
                    data: [{ value: '0', label: 'No' }, { value: '1', label: 'Yes' }],
                    value: userData.abn ? 1 : 0,
                },
            },
        };
        const goNext = () => {
            if (routeName === 'profile_gst') {
                $router.push({
                    name: 'profile'
                })
            } else {

                if (userData.role === 'locum' && (userData.contractorOnboarding)) {

                    $router.push({
                        name: "identity_document",
                    });
                } else {

                    $router.push({
                        // name: 'auth_super',
                        name: 'auth_travel',
                    })
                }

            }
        };
        const goBack = async() => {
            if (routeName === 'profile_gst') {
                $router.push({
                    name: 'profile_edit'
                })
            } else {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });  
            }
        };
        const setGst = (value) => {
            formsData.userForm.gst.value = value
            save('userForm')
        };
        const save = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    try {
                        const data = getFormValues(formName);
                        if (isEmpty(data)) {
                            const payload = { gst: 0 }
                            $store.dispatch("SAVE_USER_DATA", payload)
                        } else {
                            $store.dispatch("SAVE_USER_DATA", data)
                        }
                        goNext()
                    } catch (errors) {
                        checkFormValidation(formName, true);
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        };
        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            checkFormValidation('userForm', true);
            setFormRefs();
        });

        const {
            checkFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    await $store.dispatch("addAuthPageBack", $route.name);
                    goNext();
                } catch (error) {
                    console.log(error);
                }
            })();
        };



        return {
            setGst,
            formsData,
            checkFormValidation,
            goBack,
            save,
            userData,
            userRole,
            routeName,
            setNoGst,
            skip
        };
    },
};
</script>
